import { render, staticRenderFns } from "./ProducaoTipoProcedimento.vue?vue&type=template&id=3f45692a"
import script from "./ProducaoTipoProcedimento.vue?vue&type=script&lang=ts"
export * from "./ProducaoTipoProcedimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports